module.exports = __webpack_public_path__ + "static/img/MinjeeLee.cd85a97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MinjeeLee.jpg
// module id = wbyZ
// module chunks = 0